<template>
  <a @click.prevent="completeLecture()" href="#" v-if="showButton">
    <span v-if="size === 'lg'" class="px-4">{{ buttonText }}</span>
    <i v-else class="fas fa-forward"></i>
  </a>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['size'],
  methods: {
    completeLecture() {
      if (!this.isCompleted && this.isAuthenticated) {
        this.$api
          .completeLecture(this.lecture.id, { is_completed: !this.isCompleted })
          .then((response) => {
            this.$store.commit('completeLecture', response.data)
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) {
              iziToast.info({
                title: this.$t('Log in'),
                message: this.$t('Log in to set progress'),
              })
            } else if (error.response && error.response.status === 419) {
              iziToast.info({
                title: this.$t('Log in'),
                message: this.$t('Session expired'),
              })
            } else {
              console.error(error)
              iziToast.error({
                title: 'Error',
                message: this.$t('Something went wrong'),
                position: 'bottomLeft',
              })
            }
          })
      }
      if (this.next) {
        this.$router.push({
          name: 'lecture',
          params: { course: this.$route.params.course, lecture: this.next.id },
        })
      }
    },
  },
  computed: {
    allCompleted() {
      const completedSet = new Set(this.completed.map((row) => row.lecture_id))
      return this.lectures.every((lecture) => completedSet.has(lecture.id))
    },
    completed() {
      return this.$store.state.completed
    },
    isCompleted() {
      return _.some(this.completed, { lecture_id: this.lecture.id })
    },
    current() {
      if (this.lecture) {
        return this.lectures.findIndex((lecture) => lecture.id === this.lecture.id)
      }
      return -1
    },
    previous() {
      return this.lectures[this.current - 1]
    },
    next() {
      return this.lectures[this.current + 1]
    },
    course() {
      return this.$store.state.course
    },
    lectures() {
      let sections = _.get(this.course, 'sections')
      if (sections) {
        return _.flatten(sections.map((section) => section.lectures))
      }
      return []
    },

    lecture() {
      let sections = _.get(this.course, 'sections')
      if (sections) {
        let lectures = _.flatten(sections.map((section) => section.lectures))
        if (lectures) {
          return lectures.find((lecture) => {
            return lecture.id === parseInt(this.$route.params.lecture)
          })
        }
      }

      return {}
    },
    showButton() {
      if (this.allCompleted) return false
      return (!_.isEmpty(this.lectures) && this.next) || (!_.get(this.lecture, 'is_completed') && this.isAuthenticated)
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    progress() {
      return this.$store.getters.lectureProgress
    },
    buttonText() {
      if (this.size === 'lg') {
        if (this.isCompleted) return this.$t('Continue to next lecture')
        if (this.next && this.isAuthenticated) return this.$t('Complete and go to next lecture')
        if (!this.next && this.isAuthenticated) return this.$t('Mark lecture as completed')
      }

      if (this.isCompleted) return this.$t('Continue')
      if (this.next && this.isAuthenticated) return this.$t('Complete and continue')
      if (!this.next && this.isAuthenticated) return this.$t('Complete')

      return this.$t('Continue')
    },
  },
}
</script>
